"use client";

import dynamic from "next/dynamic";

const TTSFX = dynamic(() => import("./TTSFX"));

export default TTSFX;
